export default "__VITE_ASSET__a1c016ae__"